<template>
  <div class="relativistic">
    <TrainStation
      sceneId="relativistic"
      title="Relativistic Train Simulation"
      physics="relativistic"
      :speedValue="0.9"
      speedUnit="c"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import TrainStation from '@/components/TrainStation.vue'

export default {
  name: 'relativistic',
  components: {
    TrainStation
  }
}
</script>
